'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { initDidomi } from '@sbt-web/didomi';
import type { AdItem } from '@sbt-web/network/types';
import { getOrCreatePulse } from '@/tools/tracking/utils';
import { loadGTM } from './gtm';
interface Props {
  ads: AdItem[];
}
const addAdsToDataLayer = (ads: AdItem[]) => {
  if (window.subito.dataLayer) {
    window.subito.dataLayer.push({
      ads
    });
  }
};
export const SubitoScript = t0 => {
  const $ = _c(4);
  const {
    ads
  } = t0;
  let t1;
  let t2;
  if ($[0] !== ads) {
    t1 = () => {
      initDidomi(getOrCreatePulse(), "other");
      loadGTM();
      addAdsToDataLayer(ads);
    };
    t2 = [ads];
    $[0] = ads;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <><script dangerouslySetInnerHTML={{
        __html: "\n        window.subito = { dataLayer: [] };\n        window.dataLayer = window.dataLayer || [];\n        window.dataLayer.push({\n          event: \"gtm.js\",\n          \"gtm.start\": new Date().getTime()\n        });\n        "
      }} /><script src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/static/js/data-layer.js`} crossOrigin="anonymous" /></>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};